import { useCallback } from 'react';
import { Connection } from 'reactflow';

import { selectGraphologyGraphWithTaskAndLabwareAndDataDependencies } from '../../../features/graph/selectors';
import { selectLabwareIdsForTaskByTaskId } from '../../../features/selectors/selectLabwareIdsForTaskByTaskId';
import { useAppSelector } from '../../../hooks';
import { _isValidConnection } from '../_isValidConnection';

export const useConnectionHandler = () => {
  const labwareByHandleIndexByTaskId = useAppSelector(
    selectLabwareIdsForTaskByTaskId
  );
  const graphologyGraphWithTaskAndLabwareAndDataDependencies = useAppSelector(
    selectGraphologyGraphWithTaskAndLabwareAndDataDependencies
  );

  const isValidConnection = useCallback(
    (connection: Connection) =>
      _isValidConnection({
        connection,
        graph: graphologyGraphWithTaskAndLabwareAndDataDependencies,
        labwareByHandleIndexByTaskId,
      }),
    [
      graphologyGraphWithTaskAndLabwareAndDataDependencies,
      labwareByHandleIndexByTaskId,
    ]
  );

  return {
    isValidConnection,
  };
};
